module.exports = __webpack_public_path__ + "img/titleen.be050b8b.png";